import { render, staticRenderFns } from "./BulkEdit.vue?vue&type=template&id=3efd4d8b&scoped=true&"
import script from "./BulkEdit.vue?vue&type=script&lang=js&"
export * from "./BulkEdit.vue?vue&type=script&lang=js&"
import style0 from "./BulkEdit.vue?vue&type=style&index=0&id=3efd4d8b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efd4d8b",
  null
  
)

export default component.exports